import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CheckboxChangeEvent, GrowthScoreLabelItems, IconType, LineChartData } from '../../models/common.model';

@Component({
  selector: 'app-average-growth-score-wrapper',
  templateUrl: './average-growth-score-wrapper.component.html',
  styleUrls: ['./average-growth-score-wrapper.component.scss'],
})
export class AverageGrowthScoreWrapperComponent {
  @Input() growthScoreCardCheckbox: [];
  @Input() growthScoreCardLabel: GrowthScoreLabelItems[];
  @Input() growthScoreGraph: LineChartData;
  @Output() growthScoreCardCheckboxEvent = new EventEmitter<CheckboxChangeEvent>();

  svgPaths: { [key: string]: string } = {
    solidSquare: `${__webpack_public_path__}${IconType.SolidSquare}`,
    dottedCircle: `${__webpack_public_path__}${IconType.DottedCircle}`,
  };

  checkboxClicked(event: CustomEvent): void {
    this.growthScoreCardCheckboxEvent.emit(event.detail);
  }

  getSvgPath(labelIconKey: string): string {
    return this.svgPaths[labelIconKey];
  }
}
